/**
 * This file contains the application version.
 * It is automatically generated during the build process by update-version.js.
 * DO NOT MODIFY THIS FILE MANUALLY.
 */

export const APP_VERSION = '5.6.0';
